(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["candlelight-cursor"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-wf-vibe-effect="candle"]');
  if (!root) return;
  var holder = root.querySelector('.wf-candle__holder');
  var canvas = root.querySelector('.wf-candle__shade');
  var ctx = canvas.getContext('2d');
  var num = function (a, d) { var n = parseFloat(root.getAttribute(a)); return isNaN(n) ? d : n; };

  var s = num('data-scale', 0.4);
  var R = num('data-radius', 320);
  var lift = R * (num('data-offset', 30) / 100);
  var SHIFT_X = num('data-shift-x', 30);   // px to the right of the pointer so the click target stays visible
  var SHADE = num('data-shade', 0.5);
  var WARM = num('data-warm', 0.12);
  var SQUASH = num('data-squash', 78) / 100;   // ellipse height / width
  var FLICKER = num('data-flicker', 3) / 100;  // radius wobble amplitude
  // Anchor = the wick tip (the light source) in candle coords, at scale s.
  var AX = 17, AY = 110;

  var x = -1000, y = -1000, tx = x, ty = y;
  var running = false, dpr = 1, W = 0, H = 0;

  function active() { return document.documentElement.getAttribute('data-wf-vibe') === 'candle'; }

  function resize() {
    dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    W = window.innerWidth; H = window.innerHeight;
    canvas.width = Math.round(W * dpr);
    canvas.height = Math.round(H * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  window.addEventListener('resize', resize);
  resize();

  // One soft elliptical hole: alpha 1 through the core, easing to 0 at the rim.
  function hole(cx, cy, rx, ry, rot, strength) {
    ctx.save();
    ctx.translate(cx, cy);
    ctx.rotate(rot);
    ctx.scale(1, ry / rx);
    var g = ctx.createRadialGradient(0, 0, 0, 0, 0, rx);
    g.addColorStop(0, 'rgba(0,0,0,' + strength + ')');
    g.addColorStop(0.42, 'rgba(0,0,0,' + strength + ')');
    g.addColorStop(0.75, 'rgba(0,0,0,' + (strength * 0.35) + ')');
    g.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.fillStyle = g;
    ctx.beginPath();
    ctx.arc(0, 0, rx, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();
  }

  function draw(t) {
    // Low-frequency wobble: the pool breathes and drifts like a real flame.
    var w1 = Math.sin(t * 0.0071) * 0.6 + Math.sin(t * 0.0133) * 0.4;
    var w2 = Math.sin(t * 0.0049 + 1.7) * 0.6 + Math.sin(t * 0.0117 + 0.4) * 0.4;
    var breathe = 1 + FLICKER * w1;
    var cx = x, cy = y - lift;
    var rx = R * breathe;
    var ry = rx * SQUASH;

    ctx.clearRect(0, 0, W, H);
    ctx.globalCompositeOperation = 'source-over';
    ctx.fillStyle = 'rgba(0,0,0,' + SHADE + ')';
    ctx.fillRect(0, 0, W, H);

    // Cut the light out of the shade: one main pool + two offset lobes so the
    // union reads as an irregular, hand-drawn pool rather than a clean disc.
    ctx.globalCompositeOperation = 'destination-out';
    hole(cx, cy, rx, ry, -0.12 + w2 * 0.05, 1);
    hole(cx - rx * 0.22 + w2 * 6, cy + ry * 0.16, rx * 0.72, ry * 0.9, 0.35, 0.9);
    hole(cx + rx * 0.26 - w1 * 6, cy - ry * 0.08, rx * 0.68, ry * 0.8, -0.5, 0.85);

    // Warm cast around the flame itself.
    ctx.globalCompositeOperation = 'source-over';
    var g = ctx.createRadialGradient(x, y - lift * 0.35, 0, x, y - lift * 0.35, rx * 0.5);
    g.addColorStop(0, 'rgba(255,176,74,' + (WARM * (1 + FLICKER * 2 * w2)) + ')');
    g.addColorStop(1, 'rgba(255,176,74,0)');
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, W, H);
  }

  function frame(t) {
    if (!active()) { running = false; ctx.clearRect(0, 0, W, H); return; }
    x += (tx - x) * 0.35;
    y += (ty - y) * 0.35;
    holder.style.transform = 'translate3d(' + (x - AX * s) + 'px,' + (y - AY * s) + 'px,0) scale(' + s + ')';
    draw(t);
    requestAnimationFrame(frame);
  }

  function start() {
    if (running) return;
    running = true;
    requestAnimationFrame(frame);
  }

  document.addEventListener('mousemove', function (e) {
    tx = e.clientX + SHIFT_X; ty = e.clientY;
    if (active()) start();
  }, { passive: true });

  document.addEventListener('wf:vibe', function (e) {
    if (e.detail && e.detail.mode === 'candle') { x = tx; y = ty; start(); }
  });

  // Page loaded already in candle mode (stamped from localStorage in <head>).
  if (active()) start();

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cosmic-dust"] && !Shopify.designMode) return;
  try {
    
(function () {
  var wrap = document.querySelector('[data-wf-cosmic-dust-wrap]');
  var canvas = document.querySelector('canvas[data-wf-cosmic-dust]');
  if (!wrap || !canvas) return;

  // Desktop, fine-pointer, motion-OK only — same gate as the stardust trail.
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (reduce || !finePointer) {
    wrap.parentNode && wrap.parentNode.removeChild(wrap);
    return;
  }

  var THREE_URL = 'https://cdn.jsdelivr.net/npm/three@0.128.0/build/three.min.js';
  var MODE_KEY = 'wf-vibe';
  var MY_MODE = 'dragon'; // internal id for the "Cosmic Dust" vibe

  var engine = null;
  var active = false;
  var threeReq = null;

  function currentMode() {
    try {
      var stored = localStorage.getItem(MODE_KEY);
      return stored || 'stardust';
    } catch (e) { return 'stardust'; }
  }

  function loadThree() {
    if (window.THREE) return Promise.resolve();
    if (threeReq) return threeReq;
    threeReq = new Promise(function (resolve, reject) {
      var el = document.createElement('script');
      el.src = THREE_URL;
      el.async = true;
      el.onload = function () { resolve(); };
      el.onerror = function () { reject(new Error('three load failed')); };
      document.head.appendChild(el);
    });
    return threeReq;
  }

  function activate() {
    if (active) return;
    active = true;
    wrap.classList.add('is-on');
    loadThree().then(function () {
      if (!active) return;            // toggled away while loading
      if (!engine) engine = createEngine(canvas);
      if (engine) engine.start();
    }).catch(function () {
      // Library blocked/offline: leave the (dimmed) backdrop rather than error.
    });
  }

  function deactivate() {
    active = false;
    wrap.classList.remove('is-on');
    if (engine) engine.stop();
  }

  function apply(mode) {
    if (mode === MY_MODE) activate(); else deactivate();
  }

  apply(currentMode());
  document.addEventListener('wf:vibe', function (e) {
    apply(e.detail && e.detail.mode);
  });

  // ---- Faithful port of the "Shooting Star" pointer trail --------------------
  // Source: a Three.js/GLSL codepen. The dat.GUI panel, the intro text reveal
  // and the cursor-hiding were demo scaffolding and are dropped; the two shaders
  // and the per-pointer particle emission are kept verbatim. baseColor is now a
  // uniform (uColor) so the dust color is a theme setting.
  function createEngine(canvas) {
    var THREE = window.THREE;
    if (!THREE) return null;

    var VERT = [
      'precision highp float;',
      'precision highp int;',
      'attribute vec3 position;',
      'uniform mat4 modelViewMatrix;',
      'uniform mat4 projectionMatrix;',
      'attribute vec4 mouse;',
      'attribute vec2 aFront;',
      'attribute float random;',
      'uniform vec2 resolution;',
      'uniform float pixelRatio;',
      'uniform float timestamp;',
      'uniform float size;',
      'uniform float minSize;',
      'uniform float speed;',
      'uniform float far;',
      'uniform float spread;',
      'uniform float maxSpread;',
      'uniform float maxZ;',
      'uniform float maxDiff;',
      'uniform float diffPow;',
      'varying float vProgress;',
      'varying float vRandom;',
      'varying float vDiff;',
      'varying float vSpreadLength;',
      'varying float vPositionZ;',
      'float cubicOut(float t) {',
      '  float f = t - 1.0;',
      '  return f * f * f + 1.0;',
      '}',
      'const float PI = 3.1415926;',
      'const float PI2 = PI * 2.;',
      'void main () {',
      '  float progress = clamp((timestamp - mouse.z) * speed, 0., 1.);',
      '  progress *= step(0., mouse.x);',
      '  float startX = mouse.x - resolution.x / 2.;',
      '  float startY = mouse.y - resolution.y / 2.;',
      '  vec3 startPosition = vec3(startX, startY, random);',
      '  float diff = clamp(mouse.w / maxDiff, 0., 1.);',
      '  diff = pow(diff, diffPow);',
      '  vec3 cPosition = position * 2. - 1.;',
      '  float radian = cPosition.x * PI2 - PI;',
      '  vec2 xySpread = vec2(cos(radian), sin(radian)) * spread * mix(1., maxSpread, diff) * cPosition.y;',
      '  vec3 endPosition = startPosition;',
      '  endPosition.xy += xySpread;',
      '  endPosition.xy -= aFront * far * random;',
      '  endPosition.z += cPosition.z * maxZ * (pixelRatio > 1. ? 1.2 : 1.);',
      '  float positionProgress = cubicOut(progress * random);',
      '  vec3 currentPosition = mix(startPosition, endPosition, positionProgress);',
      '  vProgress = progress;',
      '  vRandom = random;',
      '  vDiff = diff;',
      '  vSpreadLength = cPosition.y;',
      '  vPositionZ = position.z;',
      '  gl_Position = projectionMatrix * modelViewMatrix * vec4(currentPosition, 1.);',
      '  gl_PointSize = max(currentPosition.z * size * diff * pixelRatio, minSize * (pixelRatio > 1. ? 1.3 : 1.));',
      '}'
    ].join('\n');

    var FRAG = [
      'precision highp float;',
      'precision highp int;',
      'uniform float fadeSpeed;',
      'uniform float shortRangeFadeSpeed;',
      'uniform float minFlashingSpeed;',
      'uniform float blur;',
      'uniform vec3 uColor;',
      'varying float vProgress;',
      'varying float vRandom;',
      'varying float vDiff;',
      'varying float vSpreadLength;',
      'varying float vPositionZ;',
      'highp float random(vec2 co) {',
      '  highp float a = 12.9898;',
      '  highp float b = 78.233;',
      '  highp float c = 43758.5453;',
      '  highp float dt = dot(co.xy, vec2(a, b));',
      '  highp float sn = mod(dt, 3.14);',
      '  return fract(sin(sn) * c);',
      '}',
      'float quadraticIn(float t) {',
      '  return t * t;',
      '}',
      '#ifndef HALF_PI',
      '#define HALF_PI 1.5707963267948966',
      '#endif',
      'float sineOut(float t) {',
      '  return sin(t * HALF_PI);',
      '}',
      'void main(){',
      '  vec2 p = gl_PointCoord * 2. - 1.;',
      '  float len = length(p);',
      '  float cRandom = random(vec2(vProgress * mix(minFlashingSpeed, 1., vRandom)));',
      '  cRandom = mix(0.3, 2., cRandom);',
      '  float cBlur = blur * mix(1., 0.3, vPositionZ);',
      '  float shape = smoothstep(1. - cBlur, 1. + cBlur, (1. - cBlur) / len);',
      '  shape *= mix(0.5, 1., vRandom);',
      '  if (shape == 0.) discard;',
      '  float darkness = mix(0.1, 1., vPositionZ);',
      '  float alphaProgress = vProgress * fadeSpeed * mix(2.5, 1., pow(vDiff, 0.6));',
      '  alphaProgress *= mix(shortRangeFadeSpeed, 1., sineOut(vSpreadLength) * quadraticIn(vDiff));',
      '  float alpha = 1. - min(alphaProgress, 1.);',
      '  alpha *= cRandom * vDiff;',
      '  gl_FragColor = vec4(uColor * darkness * cRandom, shape * alpha);',
      '}'
    ].join('\n');

    var PER_MOUSE = 800;
    var COUNT = PER_MOUSE * 400;
    var MA = 4; // mouse attribute stride
    var FA = 2; // aFront attribute stride
    var TIME_SCALE = 0.06; // root "speed": ms -> shader time units
    var CAMERA_Z = 5000;

    var W = window.innerWidth;
    var H = window.innerHeight;

    function fovFor(h) {
      return Math.atan((h / 2) / CAMERA_Z) * (180 / Math.PI) * 2;
    }

    var renderer;
    try {
      renderer = new THREE.WebGLRenderer({ canvas: canvas, alpha: true, antialias: false });
    } catch (e) { return null; }
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    renderer.setPixelRatio(dpr);
    renderer.setClearColor(0x000000, 0);
    renderer.setSize(W, H, false);

    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(fovFor(H), W / H, 0.1, CAMERA_Z);
    camera.position.z = CAMERA_Z;

    var uniforms = {
      resolution: { value: new THREE.Vector2(W, H) },
      pixelRatio: { value: dpr },
      timestamp: { value: 0 },
      uColor: { value: new THREE.Color(canvas.getAttribute('data-color') || '#AA8558') },
      size: { value: 0.05 },
      minSize: { value: 1 },
      speed: { value: 0.012 },
      fadeSpeed: { value: 1.1 },
      shortRangeFadeSpeed: { value: 1.3 },
      minFlashingSpeed: { value: 0.1 },
      spread: { value: 7 },
      maxSpread: { value: 5 },
      maxZ: { value: 100 },
      blur: { value: 1 },
      far: { value: 10 },
      maxDiff: { value: 100 },
      diffPow: { value: 0.24 }
    };

    var geometry = new THREE.BufferGeometry();
    var positions = new Float32Array(COUNT * 3);
    var mouse = new Float32Array(COUNT * MA);
    var aFront = new Float32Array(COUNT * FA);
    var random = new Float32Array(COUNT);
    for (var i = 0; i < COUNT; i++) {
      positions[i * 3] = Math.random();
      positions[i * 3 + 1] = Math.random();
      positions[i * 3 + 2] = Math.random();
      mouse[i * MA] = -1;
      mouse[i * MA + 1] = -1;
      mouse[i * MA + 2] = 0;
      mouse[i * MA + 3] = 0;
      random[i] = Math.random();
    }
    geometry.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3));
    geometry.setAttribute('mouse', new THREE.Float32BufferAttribute(mouse, MA));
    geometry.setAttribute('aFront', new THREE.Float32BufferAttribute(aFront, FA));
    geometry.setAttribute('random', new THREE.Float32BufferAttribute(random, 1));

    var material = new THREE.RawShaderMaterial({
      uniforms: uniforms,
      vertexShader: VERT,
      fragmentShader: FRAG,
      transparent: true,
      depthTest: false,
      blending: THREE.NormalBlending
    });

    var mesh = new THREE.Points(geometry, material);
    mesh.frustumCulled = false;
    scene.add(mesh);

    var mouseI = 0;
    var oldPos = null;
    var timestamp = 0;
    var startTime = 0;
    var rafId = null;
    var running = false;

    // Emit PER_MOUSE particles interpolated along the last mouse segment.
    // Index math (ci) mirrors the source: the mouse ring advances by
    // MA*PER_MOUSE per move; aFront writes reuse ci (writes past its length are
    // silently ignored, exactly as in the original).
    function draw(cx, cy) {
      var x = cx;
      var y = H - cy; // flip Y: up is positive in world space
      var dx = oldPos ? x - oldPos.x : 0;
      var dy = oldPos ? y - oldPos.y : 0;
      var length = Math.sqrt(dx * dx + dy * dy);
      var fx = length > 0 ? dx / length : 0;
      var fy = length > 0 ? dy / length : 0;
      var marr = geometry.attributes.mouse.array;
      var farr = geometry.attributes.aFront.array;
      for (var j = 0; j < PER_MOUSE; j++) {
        var ci = (mouseI % (COUNT * MA)) + j * MA;
        var px = oldPos ? oldPos.x + dx * (j / PER_MOUSE) : x;
        var py = oldPos ? oldPos.y + dy * (j / PER_MOUSE) : y;
        marr[ci] = px;
        marr[ci + 1] = py;
        marr[ci + 2] = timestamp;
        marr[ci + 3] = length;
        farr[ci] = fx;
        farr[ci + 1] = fy;
      }
      oldPos = { x: x, y: y };
      geometry.attributes.mouse.needsUpdate = true;
      geometry.attributes.aFront.needsUpdate = true;
      mouseI += MA * PER_MOUSE;
    }

    function onMove(e) { draw(e.clientX, e.clientY); }

    function onResize() {
      W = window.innerWidth;
      H = window.innerHeight;
      renderer.setSize(W, H, false);
      camera.fov = fovFor(H);
      camera.aspect = W / H;
      camera.updateProjectionMatrix();
      uniforms.resolution.value.set(W, H);
    }
    window.addEventListener('resize', onResize);

    function tick(now) {
      if (!running) return;
      if (!startTime) startTime = now;
      timestamp = (now - startTime) * TIME_SCALE;
      uniforms.timestamp.value = timestamp;
      renderer.render(scene, camera);
      rafId = requestAnimationFrame(tick);
    }

    function start() {
      if (running) return;
      running = true;
      // Clear any stale trail from a previous activation.
      oldPos = null;
      var marr = geometry.attributes.mouse.array;
      for (var k = 0; k < marr.length; k += MA) {
        marr[k] = -1;
        marr[k + 3] = 0;
      }
      geometry.attributes.mouse.needsUpdate = true;
      startTime = 0;
      window.addEventListener('pointermove', onMove, { passive: true });
      rafId = requestAnimationFrame(tick);
    }

    function stop() {
      running = false;
      if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
      window.removeEventListener('pointermove', onMove);
      renderer.clear();
    }

    return { start: start, stop: stop };
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stardust-cursor"] && !Shopify.designMode) return;
  try {
    
(function () {
  var canvas = document.querySelector('canvas[data-stardust]');
  if (!canvas) return;

  // Guard: no cursor / reduced motion => no trail. Merchant can opt touch in.
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var allowMobile = canvas.getAttribute('data-mobile') === 'true';
  if (reduce || (!finePointer && !allowMobile)) {
    canvas.parentNode && canvas.parentNode.removeChild(canvas);
    return;
  }

  var ctx = canvas.getContext('2d');
  var num = function (a, d) { var n = parseFloat(canvas.getAttribute(a)); return isNaN(n) ? d : n; };

  // CONFIG — a faithful port of the reference (brewchewgum.com stardust),
  // color swapped for the theme's own. Fade slider is 1..10 -> 0.01..0.10.
  var CONFIG = {
    color: canvas.getAttribute('data-color') || '#E8B45A',
    centerColor: canvas.getAttribute('data-center-color') || '#FFFFFF',
    maxParticles: num('data-max', 45),
    spawnRate: num('data-spawn', 3),
    minSize: num('data-min-size', 4),
    maxSize: num('data-max-size', 12),
    fadeSpeed: num('data-fade', 1) * 0.01,
    drift: num('data-drift', 1.2),
    gravity: num('data-gravity', 0.3),
    glowIntensity: num('data-glow', 0.9),
    twinkle: canvas.getAttribute('data-twinkle') !== 'false'
  };

  var particles = [];
  var mouseX = -100, mouseY = -100;
  var animating = false;

  // Visitor vibe choice (footer picker). Stored per browser; the footer
  // dispatches 'wf:vibe' on change so bundle order between sections never
  // matters. This effect runs only for mode 'stardust' (the default).
  var MODE_KEY = 'wf-vibe';
  var MY_MODE = 'stardust';
  var userOn = true;
  try {
    var stored = localStorage.getItem(MODE_KEY);
    if (stored) userOn = stored === MY_MODE;
    else userOn = localStorage.getItem('wf-stardust') !== 'off';
  } catch (e) {}
  document.addEventListener('wf:vibe', function (e) {
    userOn = !!(e.detail && e.detail.mode === MY_MODE);
    if (!userOn) {
      particles.length = 0;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    }
  });

  function resize() {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  }
  window.addEventListener('resize', resize);
  resize();

  function createParticle(x, y) {
    var size = CONFIG.minSize + Math.random() * (CONFIG.maxSize - CONFIG.minSize);
    return {
      x: x + (Math.random() - 0.5) * 10,
      y: y + (Math.random() - 0.5) * 10,
      size: size,
      originalSize: size,
      rotation: Math.random() * Math.PI * 2,
      rotationSpeed: (Math.random() - 0.5) * 0.15,
      opacity: 0.7 + Math.random() * 0.3,
      vx: (Math.random() - 0.5) * CONFIG.drift * 2,
      vy: (Math.random() - 0.5) * CONFIG.drift - CONFIG.gravity * 0.5,
      life: 1,
      decay: CONFIG.fadeSpeed + Math.random() * 0.015,
      points: Math.random() > 0.5 ? 4 : 5,
      twinklePhase: Math.random() * Math.PI * 2,
      twinkleSpeed: 0.05 + Math.random() * 0.1
    };
  }

  function emit(x, y) {
    if (!userOn) return;
    mouseX = x; mouseY = y;
    for (var i = 0; i < CONFIG.spawnRate; i++) {
      if (particles.length < CONFIG.maxParticles) particles.push(createParticle(mouseX, mouseY));
    }
    if (!animating) { animating = true; requestAnimationFrame(loop); }
  }

  document.addEventListener('mousemove', function (e) { emit(e.clientX, e.clientY); }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!allowMobile) return;
    var t = e.touches[0];
    if (t) emit(t.clientX, t.clientY);
  }, { passive: true });

  function drawStar(cx, cy, points, outerR, innerR, rotation) {
    ctx.beginPath();
    for (var i = 0; i < points * 2; i++) {
      var r = i % 2 === 0 ? outerR : innerR;
      var angle = (Math.PI / points) * i + rotation;
      var px = cx + r * Math.cos(angle);
      var py = cy + r * Math.sin(angle);
      if (i === 0) ctx.moveTo(px, py); else ctx.lineTo(px, py);
    }
    ctx.closePath();
  }

  function loop() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    for (var i = particles.length - 1; i >= 0; i--) {
      var p = particles[i];

      p.life -= p.decay;
      p.x += p.vx;
      p.y += p.vy;
      p.vy += CONFIG.gravity * 0.02;
      p.rotation += p.rotationSpeed;
      p.size = p.originalSize * p.life;

      if (CONFIG.twinkle) p.twinklePhase += p.twinkleSpeed;

      if (p.life <= 0 || p.size < 0.5) { particles.splice(i, 1); continue; }

      var twinkleAlpha = CONFIG.twinkle ? 0.5 + 0.5 * Math.sin(p.twinklePhase) : 1;

      ctx.save();
      ctx.globalAlpha = p.opacity * p.life * twinkleAlpha;

      // Colored star with glow
      ctx.shadowColor = CONFIG.color;
      ctx.shadowBlur = p.size * CONFIG.glowIntensity;
      ctx.fillStyle = CONFIG.color;
      drawStar(p.x, p.y, p.points, p.size, p.size * 0.4, p.rotation);
      ctx.fill();

      // Bright center dot
      ctx.shadowBlur = 0;
      ctx.globalAlpha = p.opacity * p.life * twinkleAlpha * 0.8;
      ctx.fillStyle = CONFIG.centerColor;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.size * 0.15, 0, Math.PI * 2);
      ctx.fill();

      ctx.restore();
    }

    if (particles.length > 0) requestAnimationFrame(loop);
    else animating = false;
  }
})();

  } catch(e) { console.error(e); }
})();
})();
